import { addSeconds, format, formatDistanceStrict, isValid, parse, parseISO } from "date-fns";
import { ru } from "date-fns/locale";
import { dateFormat, isoDateFormat } from "@rmp/core/utils/formats";

export function convertIsoToNumber(value: string): number;
export function convertIsoToNumber(value: null | undefined): null;
export function convertIsoToNumber(value: string | null | undefined): number | null;
export function convertIsoToNumber(value: string | null | undefined): number | null {
	return value ? parseISO(value).getTime() : null;
}

export const formatDateInterval = (start: Date | number, end: Date | number) => {
	return `с ${formatDate(start, dateFormat)} по ${formatDate(end, dateFormat)}`;
};

export const formatDate = (date: Date | number | null | undefined, dateFormat: string) => {
	return date != null && isValid(date) ? format(date, dateFormat, { locale: ru }) : "";
};

export const parseDate = (date: string, format: string = isoDateFormat) => {
	if(!date)
		return 0;
	
	return parse(date, format, 0);
};

export const parseISODate = (value: string | null | undefined) => {
	return value ? parseISO(value) : null;
};

export const formatSecondsLeft = (seconds: number) => {
	const startDate = new Date();
	const endDate = addSeconds(new Date(), seconds);
	
	return formatDistanceStrict(startDate, endDate, { unit: "second", locale: ru });
};

export const enum timezoneNames {
	KALININGRAD = "Europe/Kaliningrad",
	MOSCOW = "Europe/Moscow",
	YEKATERINBURG = "Asia/Yekaterinburg",
	OMSK = "Asia/Omsk",
	NOVOSIBIRSK = "Asia/Novosibirsk",
	IRKUTSK = "Asia/Irkutsk",
	YAKUTSK = "Asia/Yakutsk",
	VLADIVOSTOK = "Asia/Vladivostok",
	MAGADAN = "Asia/Magadan",
	KAMCHATKA = "Asia/Kamchatka",
}

export interface TimezoneOption {
	label: string;
	value: string;
}

export const RUSSIAN_TIMEZONES = [
	timezoneNames.KALININGRAD,
	timezoneNames.MOSCOW,
	timezoneNames.YEKATERINBURG,
	timezoneNames.OMSK,
	timezoneNames.NOVOSIBIRSK,
	timezoneNames.IRKUTSK,
	timezoneNames.YAKUTSK,
	timezoneNames.VLADIVOSTOK,
	timezoneNames.MAGADAN,
	timezoneNames.KAMCHATKA
] as const;
